import { combineReducers, createReducer } from 'store/createReducer';
import contact, { initialState as initContact } from 'components/ContactInfo/reducer';
import mainMenu, { initialState as initMainMenu } from 'components/MainMenu/reducer';
import { HeaderModel } from 'models/HeaderModel';
import { SetBrandsMenuAction, SET_BRANDS_MENU } from './actions';
import { isBrandsNavigationBlock } from 'models/BrandsNavigationBlock';
import { NavigationBlock } from 'models/NavigationBlock';

export const initialState: HeaderModel = {
  mainMenu: initMainMenu,
  secondaryMenu: [],
  tertiaryMenu: [],
  contact: initContact,
  contactSection: {
    blocks: [],
    contactUrl: '',
    mobileTitle: '',
    title: '',
    isCritical: false,
    message: ''
  },
  subNavigation: [],
  blackFridayActive: false,
  stripeLinks: []
};

const subNavigation = createReducer([], {
  [SET_BRANDS_MENU]: (state: NavigationBlock[], action: SetBrandsMenuAction) => {
    return state.map(block => (!isBrandsNavigationBlock(block) ? block : action.menu));
  }
});

export default combineReducers({
  ...initialState,
  contact,
  mainMenu,
  subNavigation
});
